var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c("admin-breadcrumb", {
                attrs: {
                  items: [
                    { text: "Shipping", path: { name: "admin-shipping" } },
                  ],
                  name: "Shippers",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right align-self-end", attrs: { sm: "6" } },
            [
              _c(
                "no-permission-wrapper",
                { attrs: { show: !_vm.canCreateShippers } },
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        variant: "success",
                        disabled: !_vm.canCreateShippers,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openNewShipperModal.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Add New Shipper")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Shippers",
                    "sub-title": "Manage all shippers created in GreenLists",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c("b-form-select", {
                            staticClass: "w-auto ml-2",
                            attrs: { options: _vm.sortingOptions },
                            on: { change: () => _vm.loadShippers() },
                            model: {
                              value: _vm.sorting,
                              callback: function ($$v) {
                                _vm.sorting = $$v
                              },
                              expression: "sorting",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "w-auto ml-2",
                            attrs: { options: _vm.statusOptions },
                            on: { change: () => _vm.loadShippers() },
                            model: {
                              value: _vm.filters.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "status", $$v)
                              },
                              expression: "filters.status",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("admin-shippers-table", {
                    attrs: { shippers: _vm.shippers },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("admin-new-shipper-modal", {
        ref: "newShipperModal",
        on: { created: _vm.newShipperCreated },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }